const lang = {
  "common.and": "and",
  "common.or": "or",
  "common.yes": "yes",
  "common.delete": "Delete",
  "common.loading": "Loading",
  "common.continue": "Continue",
  "common.done": "Done",
  "common.close": "Close",
  "common.accept": "Accept",
  "common.property": "Property",
  "common.status": "Status",
  "common.back": "Back",
  "common.pause": "Pause",
  "common.edit": "Edit",
  "common.connecting": "Connecting",
  "common.manage": "Manage",
  "common.download": "Download",
  "common.apply": "Apply",
  "common.active": "Active",
  "common.setup": "Set up",
  "common.connect": "Connect",
  "common.inactive": "Inactive",
  "common.activate": "Activate",
  "common.skip": "Skip",
  "common.cancel": "Cancel",
  "common.account": "Account",
  "common.regenerate": "Regenerate",
  "common.file": "File",
  "common.send": "Send",
  "common.call": "Call",
  "common.photo": "Photos",
  "common.emoji": "Emoji",
  "common.runAi": "Run conversational",
  "common.remove": "Remove",
  "common.reset": "Reset",
  "common.clear": "Clear",
  "common.configure": "Configure",
  "common.confirmInactive": "Yes, inactive it",
  "common.confirmContinue": "Yes, continue",
  "common.confirmDelete": "Yes, delete it",
  "common.confirmScan": "Yes, scan it",
  "common.error": "Error",
  "common.tryItLater": "There was an error, try again later",
  "common.success": "Success",
  "common.today": "Today",
  "common.week": "This week",
  "common.7days": "Last 7 days",
  "common.30days": "Last 30 days",
  "common.thisMonth": "This month",
  "common.lastMonth": "Last month",
  "common.custom": "Custom",
  "common.all": "All Days",
  "common.date": "Date",
  "common.name": "Name",
  "common.company": "Account",
  "common.message": "Message",
  "common.chat": "Chat",
  "common.next": "Next",
  "common.previous": "Previous",
  "common.noResults":
    "There are no records to display for the selected date range",
  "common.results": "{total} records",
  "common.body": "Body",
  "common.tags": "Tags",
  "common.save": "Save",
  "common.saveClose": "Save and close",
  "common.submitChanges": "Submit changes",
  "common.updating": "Updating...",
  "common.newConversation": "New conversation",
  "common.create": "Create",
  "common.phone": "Phone number",
  "common.contactName": "Contact name",
  "common.optional": "Optional",
  "common.signUp": "Sign up",
  "common.copyLink": "Link copied",
  "common.copyCode": "Code copied",
  "common.share": "Share",
  "common.embed": "Embed",
  "common.virtualAssistant": "Virtual Assistant",
  "common.scan": "Scan",
  "common.rescan": "Re-scan",
  "common.add": "Add",
  "common.recommended": "Recommended",
  "common.setUp": "Set up",
  "common.typeText": "Type some text...",
  "common.connected": "Connected",
  "common.disconnected": "not connected",
  "common.searchText": "Search in text…",
  "common.characteres": "characters",
  "common.wordpress": "WordPress",
  "common.seeMessage": "View message",
  "common.analyze": "Analyze",
  "common.filter": "Filter",
  "common.filterConvs": "Filter chats",
  "common.reviewNow": "Review now",
  "common.analyzedOn": "Last analyzed {date}",
  "common.available": "Available",
  "common.activeConfig": "Active configuration",
  "common.invalidDomain":
    "This website is not valid. Please enter an allowed domain.",

  "settings.pageTitle": "Settings",
  "settings.pageDescription": "Adjust your preferences",
  "settings.accountTitle": "Account",
  "settings.language": "Language",
  "settings.company": "Company Information",
  "settings.api": "API Keys",
  "settings.company.desc": "Update your company information, such as name",
  "settings.settingsTitle": "Settings",
  "settings.channels": "Channels",
  "settings.connect": "Connect",
  "settings.integrations": "Integrations",
  "settings.ai": "AI Settings",
  "settings.teams": "Team",
  "settings.payment": "Billing",
  "settings.usage": "Usage",
  "settings.pushNotificationsDescription":
    "Control push notifications on your device",
  "settings.pushNotificationsDenied":
    "Push notifications are disabled. Enable them in device settings to receive updates.",
  "api.title": "API Keys",
  "api.subTitle": "Manage your API keys",
  "api.description": "Check our full documentation on how to use the API.",
  "api.regenerate.warningTitle":
    "Are you sure you want to regenerate this API key?",
  "api.regenerate.warningDesc":
    "Regenerating the API key will invalidate the current one, and you will need to update your applications accordingly.",

  "auth.title": "Your 24/7 AI support agent",
  "auth.description":
    "Instantly resolve customer questions on your website, WhatsApp and Instagram, with powerful AI agents you can train in minutes. No code required.",
  "auth.description.mobile":
    "Instant replies to your customers on web and WhatsApp. No code. Ready in minutes.",
  "auth.login.title": "Sign in",
  "auth.login.email": "Email",
  "auth.login.password": "Password",
  "auth.login.login": "Log in",
  "auth.login.registerLabel": "New to Visito?",
  "auth.login.register": "Create an account",
  "auth.login.getAdemo": "Request a demo",
  "auth.login.forgotPassword": "Click Here",
  "auth.login.forgotLabel": "Forgot Password?",
  "auth.login.google": "Sign in with Google",
  "auth.login.microsoft": "Sign in with Microsoft",
  "auth.login.error": "Invalid email or password",
  "auth.register.google": "Create account with Google",
  "auth.register.microsoft": "Register with Microsoft",
  "auth.register.title": " Get started for free",
  "auth.register.company": "Company name",
  "auth.register.web": "Website",
  "auth.register.email": "Email",
  "auth.register.password": "Password",
  "auth.register.register": "Create account",
  "auth.register.loginLabel": "Already have an account?",
  "auth.register.login": "Sign in",
  "auth.register.loginTerms": "Terms of Service",
  "auth.register.loginPrivacy": "Privacy Policy",
  "auth.register.continuing": "By continuing, you agree to our",
  "auth.register.titleCloudbeds": "Create your Visito account",
  "auth.registerUser.title": "Accept your invitation",
  "auth.registerUser.subtitle":
    "You're accepting an invitation to join Visito. Create your account to continue.",
  "auth.registerUser.googleOption":
    "Create your account with Google (same email as the invite).",
  "auth.registerUser.passwordOption": "Create your account with a password.",
  "auth.registerUser.nextStepsTitle": "Next steps",
  "auth.registerUser.stepOne": "Continue with Google or create a password.",
  "auth.registerUser.stepTwo": "If using password, click Register when ready.",
  "auth.registerUser.stepThree":
    "If Google selects the wrong account, switch to your invited email.",
  "auth.registerUser.error":
    "The email you're trying to sign up with doesn't match the one in your invitation",
  "auth.forgotPassword.title": "Recover password",
  "auth.forgotPassword.description":
    "Enter the email address associated with your account, and we'll send you a link to reset your password.",

  "auth.forgotPassword.email": "Email",
  "auth.forgotPassword.submit": "Submit",
  "auth.forgotPassword.success":
    "A link to reset your password has been sent to your email",
  "auth.forgotPassword.error": "Email not found. Please verify and try again.",
  "auth.resetPassword.title": "Reset Your Password",
  "auth.resetPassword.password": "New Password",
  "auth.resetPassword.submit": "Reset",
  "auth.resetPassword.cancel": "Cancel",
  "auth.resetPassword.success":
    "Your password has been successfully reset. You can now log in to your account using your new password.",
  "auth.resetPassword.description": "Please choose a new password below.",
  "auth.userInvite.success": "Invitation successfully accepted",
  "esc.needsReview": "Review",
  "esc.escalation": "Review",
  "esc.clickToView": "Click to view",
  "esc.tapToView": "Tap to view",
  "esc.solve": "Resolve escalation",
  "support.liveChat": "Live Chat",
  "support.guide": "Read Docs",
  "support.email": "Email Us",
  "support.call": "Schedule a Call",

  "nav.inbox": "Inbox",
  "nav.integrations": "Integrations",
  "nav.payments": "Payments",
  "nav.home": "Home",
  "nav.channels": "Channels",
  "nav.menu": "Menu",
  "nav.outbound": "Events",
  "nav.ai": "AI",
  "nav.aiSetup.progress": "Setup {completed}/3",
  "nav.aiSetup.title": "Account setup",
  "nav.aiSetup.progressSummary": "{completed} of {total} completed",
  "nav.aiSetup.progressSummary.blocked":
    "{completed} of {total} completed • Connect a channel to go live.",
  "nav.aiSetup.popover.title": "Finish AI setup",
  "nav.aiSetup.popover.subtitle": "Complete these steps to go live.",
  "nav.aiSetup.completed.title": "Account setup completed",
  "nav.aiSetup.completed.subtitle": "Your AI is live on at least one channel.",
  "nav.aiSetup.completed.cta": "Go to Inbox",
  "nav.aiSetup.item.knowledge": "Knowledge",
  "nav.aiSetup.item.knowledge.desc":
    "This is how you teach your AI: add website, text, or files.",
  "nav.aiSetup.item.integrations": "Integrations",
  "nav.aiSetup.item.integrations.desc":
    "Connect your provider to enrich replies.",
  "nav.aiSetup.item.channels": "Channels",
  "nav.aiSetup.item.channels.desc":
    "Connect at least one channel to go live.",
  "nav.aiSetup.item.teamMembers": "Team members",
  "nav.aiSetup.item.teamMembers.desc":
    "Invite your team so they can help manage conversations.",
  "nav.aiSetup.item.mobileApps": "Mobile apps",
  "nav.aiSetup.item.mobileApps.desc":
    "Install the Visito app to receive push notifications on the go.",
  "nav.aiSetup.action.go": "Go",
  "nav.whatsNew.trigger": "What's new",
  "nav.whatsNew.title": "What's new in Visito",
  "nav.whatsNew.subtitle": "Recent product updates for your team.",
  "nav.whatsNew.new": "New",
  "nav.whatsNew.item.cta": "Open",
  "nav.whatsNew.item.setup.title": "Account setup progress",
  "nav.whatsNew.item.setup.desc":
    "Track your onboarding progress directly from the navbar.",
  "nav.whatsNew.item.playground.title": "Playground quick prompts",
  "nav.whatsNew.item.playground.desc":
    "Use contextual starter prompts to test your AI faster.",
  "nav.whatsNew.item.team.title": "Team members on mobile",
  "nav.whatsNew.item.team.desc":
    "Manage team invites and roles from mobile settings.",
  "nav.whatsNew.item.mobile.title": "Mobile notifications",
  "nav.whatsNew.item.mobile.desc":
    "Install the mobile app to stay on top of new conversations.",
  "nav.whatsNew.item.itemsCatalog.title": "Items catalog for direct sales",
  "nav.whatsNew.item.itemsCatalog.desc":
    "Create items like day passes or massages, add required details, and let AI collect payment links in chat.",
  "nav.whatsNew.item.followUps.title": "Follow-up controls",
  "nav.whatsNew.item.followUps.desc":
    "You can now choose how long AI waits before checking inactive chats and how aggressive follow-ups should be (High, Default, or Low) based on conversation impact.",
  "nav.whatsNew.item.igDocs.title": "Instagram document sending",
  "nav.whatsNew.item.igDocs.desc":
    "You can now send documents from Visito to Instagram as chat attachments.",
  "nav.whatsNew.item.mobileTeam.title": "Manage team members from the app",
  "nav.whatsNew.item.mobileTeam.desc":
    "Invite and manage your team directly from Visito mobile.",
  "nav.whatsNew.item.mobileTeam.android": "Download for Android",
  "nav.whatsNew.item.mobileTeam.ios": "Download for iOS",
  "nav.crm": "CRM",
  "nav.leads": "Leads",
  "nav.items": "Items",
  "nav.settings": "Settings",
  "nav.notificationsToolTip": "Control alert sounds and desktop notifications",

  "nav.notifications": "Notifications",
  "nav.logout": "Log out",

  "nav.limitApproaching": "Your credits are running low.",
  "nav.payment": "You’ve used up all your message credits.",
  "nav.paymentCTA": "Get more credits",

  "nav.channelOnboarding": "Need help?",
  "nav.channelOnboardingCTA": "Schedule a call",

  "nav.pastDue": "Your payment failed.",
  "nav.pastDueCTA": "Update your payment method to keep your account active.",
  "nav.accountList": "Accounts",
  "nav.createAccount": "Create new account",
  "nav.helpCenter": "Help Center",
  "nav.connect": "Connect",
  "nav.helpChat": "Chat with us",

  "ai.agent.title": "Your AI Agent",
  "ai.agent.description":
    "This is the core engine. Its job is to connect all the pieces of your ecosystem in real time:",

  "ai.agent.feature.knowledge": "Looks up your knowledge base to find answers.",
  "ai.agent.feature.behavior":
    "Follows your personality settings, tone of voice, and business rules.",
  "ai.agent.feature.integrations":
    "Performs external actions like checking availability.",
  "ai.agent.feature.channels":
    "Delivers the final response to customers through your channels.",

  "ai-settings.workingHours": "Working hours",
  "ai-settings.workingHoursDescription":
    "If an escalation occurs outside of working hours, the AI will inform the guest of the working hours.",
  "ai-settings.title": "AI - Settings",
  "ai-settings.paneTitle": "AI Configuration",
  "ai-settings.notifications": "Notifications",
  "ai-settings.notificationsDescription":
    "Download the Visito App and get push notifications for unresolved conversations.",
  "ai-settings-intructions.title": "Ajustes",
  "ai.onboarding.title": "Let's create your AI agent",
  "ai.onboarding.error":
    "We couldn’t scan your website. Try another URL or continue with manual setup.",

  "ai.onboarding.desc":
    "Provide your website so the AI can learn about your business.",
  "ai.onboarding.cta": "Create Agent",
  "ai.onboarding.cta.skip": "Skip, I’ll set it up manually",
  "ai.onboarding.sourceNotice": "You can add more data sources later.",
  "ai.onboarding.readingWebsite": "Reading your website",
  "ai.onboarding.teachingAgent": "Teaching your agent",
  "ai.onboarding.creatingAgent": "Preparing your agent",
  "ai.onboarding.preview.support":
    "Hi! 👋 I'm here to help with any question or issue. How can I assist you today?",
  "ai.onboarding.preview.sales":
    "Hi! 👋 Looking for the best deals? I can show you options that match what you need. 🚀",
  "ai.onboarding.preview.booking":
    "Welcome 👋 Would you like to check availability, make a reservation, or request assistance? I’m here to help. 🛎️",
  "ai.onboarding.preview.ecommerce":
    "Hi 👋 Are you looking for something specific? I can help you find the perfect product. 🛍️",
  "ai.onboarding.preview.internal":
    "Hi team 👋 Need help with internal processes or specific information? I'm here to support you.",
  "ai.onboarding.preview.education":
    "Hi 👋 What topic would you like to learn or review today? I can guide you step by step. 🎓",
  "ai.onboarding.preview.other":
    "Hi 👋 I'm your virtual assistant. How can I help you today?",
  "ai.onboarding.agent.preview":
    "This is how your customers will see your agent",
  "ai.onboarding.agent.learn": "I will learn from: ",
  "ai.onboarding.agent.online": "Online",
  "ai.onboarding.agent.processing": "Working",
  "ai.onboarding.building": "Building your Agent",
  "ai.onboarding.profile.title": "Tell us about you",
  "ai.onboarding.profile.desc":
    "Enter your name and phone number to set up your account",
  "ai.onboarding.profile.phoneNumber": "Phone Number",
  "ai.onboarding.profile.invalidPhone": "Please enter a valid phone number",
  "ai.onboarding.profile.name": "Full Name",
  "ai.onboarding.type.title": "What do you want your agent to do?",
  "ai.onboarding.type.description":
    "Define how your agent will help your business.",
  "ai.onboarding.company.description":
    "Review and edit your company context before creating your agent.",
  "ai.onboarding.companyName.label": "Company Name",
  "ai.onboarding.companyName.placeholder": "VISITO AI",
  "ai.onboarding.companyName.required": "Company name is required.",
  "ai.onboarding.aboutCompany.label": "About Company",
  "ai.onboarding.aboutCompany.placeholder":
    "Summarize what your company does, your products/services, and your value proposition.",
  "ai.onboarding.aboutCompany.required": "About Company is required.",
  "ai.onboarding.company.contextHelp":
    "Your agent will be trained with this data. You can add more context later.",
  "ai.onboarding.type.support.label": "Customer Support",
  "ai.onboarding.type.support.desc": "Resolves common questions 24/7.",
  "ai.onboarding.type.sales.label": "Sales & Leads",
  "ai.onboarding.type.sales.desc":
    "Captures and qualifies potential customers.",
  "ai.onboarding.type.booking.label": "Bookings",
  "ai.onboarding.type.booking.desc": "Manages scheduling and availability.",
  "ai.onboarding.type.ecommerce.label": "Shopping Assistant",
  "ai.onboarding.type.ecommerce.desc":
    "Guides customers through products and catalog.",
  "ai.onboarding.type.internal.label": "Internal Use / HR",
  "ai.onboarding.type.internal.desc":
    "Supports manuals, processes, and team questions.",
  "ai.onboarding.type.education.label": "Education",
  "ai.onboarding.type.education.desc": "Explains lessons or course materials.",
  "ai.onboarding.type.other.label": "Other / Custom",
  "ai.onboarding.type.other.desc": "Define your own rules.",
  "ai.onboarding.extraPlaceholder":
    "Describe how you want your agent to work (optional)",
  "ai.viz.title": "We train your agent using your website",
  "ai.viz.description": "The AI learns from your content to respond better",

  "ai.pageTitle": "Artificial Intelligence",
  "ai.pageDescription": "Fine-tune and experiment with your AI agent",
  "ai.contextTitle": "Knowledge Base",
  "ai.contextDescription": "Manage your knowledge to train your AI agent",
  "ai.playgroundTitle": "AI Agent Sandbox",
  "ai.playgroundDescription":
    "Interact with your AI agent to observe its responses",

  "ai.agent": "Your AI Agent",
  "ai.agent.update": "Apply Changes",
  "ai.playground": "Playground",
  "ai.playground.onboarding": "Test",
  "ai.playground.trained": "Your AI is ready",
  "ai.playground.notTrained":
    "Your AI isn't trained yet. Train it so it can start answering questions about your business",
  "ai.playground.desc":
    "Test your AI in a sample playground chat just like it would in a real conversation.",
  "ai.playground.test": "Test Your AI",

  "ai.playground.help.title": "Playground",
  "ai.playground.help.subtitle":
    "Interact with your agent just like your customers will.",
  "ai.playground.help.status.title": "Synced and ready",
  "ai.playground.help.status.desc":
    "Your agent has full access to your Knowledge Base, Behavior settings, and active Integrations.",
  "ai.playground.help.suggestions.title": "Interaction suggestions",
  "ai.playground.help.suggestions.accuracy.title": "Response accuracy",
  "ai.playground.help.suggestions.accuracy.desc":
    "Ask for specific details (prices, policies, hours) to validate its sources.",
  "ai.playground.help.suggestions.tone.title": "Style and tone",
  "ai.playground.help.suggestions.tone.desc":
    "Check that it speaks with the personality and format you defined in its behavior settings.",
  "ai.playground.help.suggestions.logic.title": "Logic and actions",
  "ai.playground.help.suggestions.logic.desc":
    "Make sure it can understand complex intents, apply business rules, and trigger escalations when needed.",

  "ai.playground.help.footer":
    "If you change the configuration, remember to clear the chat to apply the updates.",
  "ai.playground.welcome.connect.title": "Go live faster",
  "ai.playground.welcome.connect.subtitle":
    "Connect channels and integrations to launch your AI in real conversations.",
  "ai.playground.welcome.connect.channels.desc":
    "Connect where customers message you: WhatsApp, Instagram, Messenger.",
  "ai.playground.welcome.connect.integrations.desc":
    "Connect providers so your AI can answer with live business data.",
  "ai.playground.welcome.connect.status.connected": "Connected",
  "ai.playground.welcome.connect.status.notConnected": "Not connected",
  "ai.playground.welcome.next.title": "Ready for the next step?",
  "ai.playground.welcome.next.subtitle":
    "Complete these steps to finish setup and start operating.",
  "ai.playground.welcome.next.toggle": "Toggle next steps",
  "ai.playground.welcome.next.configure.title": "Configure your AI agent",
  "ai.playground.welcome.next.configure.desc":
    "Add context, rules, and workflows.",
  "ai.playground.welcome.next.configure.cta": "Configure",
  "ai.playground.welcome.next.channels.title": "Deploy your AI",
  "ai.playground.welcome.next.channels.desc":
    "Launch where customers message you.",
  "ai.playground.welcome.next.channels.cta": "Deploy",
  "ai.playground.welcome.next.integrations.title": "Connect to your systems",
  "ai.playground.welcome.next.integrations.desc":
    "Take actions and share live data.",
  "ai.playground.welcome.next.integrations.cta": "Connect",
  "ai.playground.welcome.paywall.title": "Start your free trial",
  "ai.playground.welcome.paywall.desc":
    "Choose the best plan and unlock channels, integrations, and advanced AI workflows.",
  "ai.playground.welcome.paywall.perMonth": "/ mo",
  "ai.playground.welcome.paywall.creditOptions": "Credit options",
  "ai.playground.welcome.paywall.creditsOption":
    "{credits, number} credits / mo",
  "ai.playground.welcome.paywall.includes": "Includes:",
  "ai.playground.welcome.paywall.mostPopular": "Most popular",
  "ai.playground.welcome.paywall.starter.title": "Starter",
  "ai.playground.welcome.paywall.starter.desc":
    "AI-powered support and booking across your messaging channels.",
  "ai.playground.welcome.paywall.starter.feature.1":
    "AI agent for support and booking",
  "ai.playground.welcome.paywall.starter.feature.2":
    "WhatsApp, Instagram, and website chat",
  "ai.playground.welcome.paywall.starter.feature.3": "Shared team inbox",
  "ai.playground.welcome.paywall.starter.feature.4": "Deep integrations",
  "ai.playground.welcome.paywall.starter.feature.5":
    "Available in 100+ languages",
  "ai.playground.welcome.paywall.starter.feature.6": "Basic analytics",
  "ai.playground.welcome.paywall.pro.title": "Pro",
  "ai.playground.welcome.paywall.pro.desc":
    "Advanced models, deeper analytics, and dedicated onboarding.",
  "ai.playground.welcome.paywall.pro.includes": "Everything in Starter, plus:",
  "ai.playground.welcome.paywall.pro.feature.1": "Access to advanced models",
  "ai.playground.welcome.paywall.pro.feature.2": "Dedicated onboarding",
  "ai.playground.welcome.paywall.pro.feature.3": "Priority support",
  "ai.playground.welcome.paywall.pro.feature.4":
    "Advanced analytics and reporting",
  "ai.playground.welcome.paywall.pro.feature.5": "Custom AI workflows",
  "ai.playground.welcome.paywall.pro.feature.6": "Remove Visito branding",
  "ai.playground.welcome.paywall.enterprise.title": "Enterprise",
  "ai.playground.welcome.paywall.enterprise.desc":
    "Custom workflows and integrations for growing businesses.",
  "ai.playground.welcome.paywall.enterprise.custom": "Custom",
  "ai.playground.welcome.paywall.enterprise.includes":
    "Everything in Pro, plus:",
  "ai.playground.welcome.paywall.enterprise.feature.1":
    "Custom credit packages",
  "ai.playground.welcome.paywall.enterprise.feature.2":
    "Custom onboarding and workflow design",
  "ai.playground.welcome.paywall.enterprise.feature.3":
    "Dedicated support and SLA options",
  "ai.playground.welcome.paywall.enterprise.feature.4":
    "Custom integrations",
  "ai.playground.welcome.paywall.enterprise.feature.5":
    "Multi-property management",
  "ai.playground.welcome.paywall.enterprise.cta": "Request a quote",
  "ai.playground.welcome.paywall.enterprise.intent.channels": "channels",
  "ai.playground.welcome.paywall.enterprise.intent.integrations":
    "integrations",
  "ai.playground.welcome.paywall.enterprise.mail.subject":
    "Enterprise inquiry from welcome flow ({intent})",
  "ai.playground.welcome.paywall.enterprise.mail.body":
    "Hi team,\n\nI want enterprise pricing for {company}. I'm currently interested in {intent}.\n\nPlease contact me with details.\n",
  "ai.playground.welcome.paywall.cta": "Start for free",
  "ai.playground.welcome.paywall.creditsInfo.title": "How credits work",
  "ai.playground.welcome.paywall.creditsInfo.body":
    "1 credit = 1 AI message reply. Customer messages and your team's manual replies are always free.",
  "ai.playground.starters.label": "Try asking...",
  "ai.playground.starters.hint": "Click a suggestion to send instantly.",
  "ai.playground.starters.companyFallback": "your business",
  "ai.playground.starters.channel.whatsapp": "WhatsApp",
  "ai.playground.starters.channel.instagram": "Instagram",
  "ai.playground.starters.channel.messenger": "Messenger",
  "ai.playground.starters.prompt.company":
    "What does {company} do, and who is the ideal customer?",
  "ai.playground.starters.prompt.knowledge.ready":
    "What information do you already know about {company} from my training sources?",
  "ai.playground.starters.prompt.knowledge.missing":
    "What key info should I add first so you can answer better about {company}?",
  "ai.playground.starters.prompt.provider.ready":
    "A guest wants to book. How would you guide them step by step?",
  "ai.playground.starters.prompt.provider.missing":
    "If someone asks to book now, how should you respond without a connected provider?",
  "ai.playground.starters.prompt.channels.ready":
    "Show an ideal first reply for a new message from {channels}.",
  "ai.playground.starters.prompt.channels.missing":
    "Write a strong first response to a new customer inquiry.",
  "ai.playground.starters.prompt.context.whatIs": 'What is "{topic}"?',
  "ai.playground.starters.prompt.context.tellMeMore":
    'Can you tell me more about "{topic}"?',
  "ai.playground.starters.prompt.context.howWorks":
    'How does "{topic}" work?',

  "ai.source.active": "Active source",
  "ai.source.inactive": "Source not configured",
  "ai.sources.flow": "How your AI agent works",
  "ai.sources.flow.desc":
    "Your sources feed the agent. It uses your rules and integrations to respond across all your channels.",
  "ai.sources.agent": "Your AI Agent",
  "ai.sources.agent.desc": "Centralizes, processes, and responds.",
  "ai.sources": "Training sources",
  "ai.sources.onboarding": "Train",
  "ai.sources.alert": "Train your AI",
  "ai.sources.alert.desc":
    "Add content so your agent can learn about your business. Upload it in seconds: your website, text, or files.",
  "ai.sources.alert.button": "Got it",
  "ai.sources.desc":
    "Your AI learns from the content of these sources to answer questions about your business.",
  "ai.sources.website": "Website",
  "ai.sources.website.desc":
    "Extract content from an entire website or from a specific URL to train your AI",
  "ai.sources.website.scanning": "Website analysis in progress",
  "ai.sources.website.scanning.info":
    "We're analyzing your website. This may take a few minutes, but in the meantime, you can add more sources or test your AI",
  "ai.sources.website.completed": "Website analysis completed",
  "ai.sources.website.rescan.confirmation":
    "Are you sure you want to rescan this website?",
  "ai.sources.website.rescan.confirmationDesc":
    "Rescanning this website will delete all previously extracted content and replace it with new data from the latest scan",
  "ai.sources.website.delete.confirmation":
    "Are you sure you want to delete this URL?",
  "ai.sources.website.delete.confirmationDesc":
    "Deleting this URL will remove its content from your AI agent's knowledge base. It will no longer be used to generate responses",
  "ai.sources.website.fullCrawl":
    "This will crawl all the links starting with the above URL",
  "ai.sources.website.fullCrawlTitle": "Crawl Entire Website",
  "ai.sources.website.singleCrawlTitle": "Specific URL",
  "ai.sources.website.singleCrawl": "Extract content from one specific URL",
  "ai.sources.website.max":
    "You've reached the limit of {limit} active URLs. Please delete or deactivate one to add another",
  "ai.sources.text": "Text",
  "ai.sources.text.desc":
    "Add free-form text to teach your AI new details or clarify information about your business",
  "ai.textHelp.title": "Content Suggestions",
  "ai.textHelp.intro":
    "This space is ideal for information that's not on your website or in your files.",
  "ai.textHelp.faqs.title": "Frequently Asked Questions (FAQs)",
  "ai.textHelp.faqs.desc":
    "Copy and paste Question-Answer pairs your customers usually ask.",
  "ai.textHelp.specific.title": "Specific Data",
  "ai.textHelp.specific.desc":
    "Price lists, opening hours, cancellation policies.",
  "ai.textHelp.format.title": "Clear Formatting",
  "ai.textHelp.format.desc":
    "Use headings and bullet lists. AI reads structured content more easily.",
  "ai.textHelp.tip":
    "Tip: You don't need to write like a human. Raw, direct information works best.",
  "ai.instructionsHelp.title": "Defining your agent",
  "ai.instructionsHelp.intro":
    "Here you define its identity and ground rules. Think of this as the job description for your new digital employee.",
  "ai.instructionsHelp.role.title": "Role and goal",
  "ai.instructionsHelp.role.desc":
    'Tell it who it is and what it should achieve. Example: "You are a concierge specialized in tourism and your goal is to sell tours."',
  "ai.instructionsHelp.tone.title": "Tone of voice",
  "ai.instructionsHelp.tone.desc":
    "How should it speak? Decide whether you want a formal, serious tone or a friendly, casual one that can use emojis.",
  "ai.instructionsHelp.rules.title": "Rules and limits",
  "ai.instructionsHelp.rules.desc":
    'Set strict rules. Example: "Never make up prices", "Always reply in Spanish", "Don’t talk about politics."',
  "ai.instructionsHelp.tip":
    "Tip: Be specific. If you want short answers (under 50 words), write that explicitly here.",

  "ai.connect.title": "Connect",
  "ai.connect.desc":
    "Connect your AI to a channel such as WhatsApp, Instagram, or Messenger.",
  "ai.connect.status": "Your AI is not connected to any channel",
  "ai.connect.cta": "Connect your AI",

  "ai.sidebar.sources": "Knowledge",
  "ai.sidebar.behavior": "Behavior",
  "ai.sidebar.connections": "Connections",
  "ai.sidebar.agent.active": "Active Agent",
  "ai.sidebar.agent.active.desc": "Your AI is ready. Go to home.",
  "ai.sidebar.agent.setup": "Set up your agent",
  "ai.sidebar.agent.setup.desc": "Add a source.",
  "ai.home.improve.title": "Improve responses",
  "ai.home.improve.subtitle":
    "Optional, but recommended to improve quality and coverage.",
  "ai.home.improve.knowledge.desc":
    "Teach your AI with more business information sources.",
  "ai.home.improve.integrations.desc":
    "Connect providers to enrich data-driven answers.",

  "ai.sources.text.tip.title":
    "Add text just like you would explain it to a teammate.",
  "ai.sources.text.tip.examples":
    "For example:\n- Our business hours are Monday to Friday, 9 AM to 6 PM.\n- To request support, customers must give us their order number and email address.",
  "ai.sources.files": "Files",
  "ai.sources.files.desc":
    "Upload files to teach your AI. Your AI won't share these files - they're only used as a knowledge base to generate responses",
  "ai.sources.files.upload": "Upload File",
  "ai.sources.files.upload.label": "Upload an Image, PDF or CSV file",
  "ai.sources.files.delete": "Delete File",
  "ai.sources.files.delete.confirmation":
    "Are you sure you want to delete this file?",
  "ai.sources.files.delete.confirmationDesc":
    "Deleting this file will remove it from your AI agent's knowledge base. It will no longer be used to generate responses",
  "ai.sources.files.analyzed": "Analyzed Files",
  "ai.sources.files.limit": "The file is too big. Limit: 15MB",
  "ai.sources.files.max":
    "The limit of active files is {limit}. Please delete or deactivate one to upload a new file",
  "ai.sources.providers": "Providers",
  "ai.sources.providers.desc":
    "Connect external integrations to give your AI access to additional data and improve its responses.",
  "ai.sources.providers.manage":
    "Manage your connected providers from the integrations page. You can add, update, or remove them anytime.",
  "ai.sources.providers.empty":
    "No providers connected yet. Link one from the Integrations page to start using external data",
  "ai.sources.providers.setUp": "Set Up a Provider",
  "ai.sources.channels": "Channels",
  "ai.sources.channels.desc":
    "Connect your assistant to your main channels and information sources.",
  "ai.sources.customerContext": "Customer Context",
  "ai.sources.customerContext.desc":
    "Add information that will only be included in responses when a booking or order is confirmed. Use this to provide details like room numbers, Wi-Fi passwords, or special access codes",
  "ai.settings": "Settings",
  "ai.settings.desc":
    " Adjust your AI agent's behavior, personality, and escalation rules",
  "ai.settings.cta": "AI Settings",
  "ai.settings.instructions": "Rules & Tone",
  "ai.settings.instructions.desc":
    "Adjust your agent's tone and behavior. This does not add knowledge—only guides how it responds.",
  "ai.settings.escalations": "Escalations",
  "ai.settings.escalations.desc":
    "Define which situations trigger an escalation. If a user asks for help or sends a payment receipt, the AI will stop responding and your team will be notified.",
  "ai.settings.escalations.enable": "Escalations enabled",
  "ai.settings.escalations.disabled": "Escalations disabled",
  "ai.settings.escalations.disabled.alert":
    "Enable escalations to manage your custom rules",
  "ai.settings.escalations.enable.desc":
    "When on, the AI agent pauses its reply and alerts staff whenever a rule is triggered.",
  "ai.settings.escalations.setup": "Escalations setup",
  "ai.settings.escalations.setup.desc":
    "Choose what the AI agent should do in special situations.",
  "ai.settings.escalations.rules.name": "Rule name",
  "ai.settings.escalations.rules.content": "Keyword/phrase",
  "ai.settings.escalations.rules.add": "Add rule",
  "ai.settings.escalations.rules.create": "Save rule",
  "ai.settings.escalations.rules.new": "New escalation rule",
  "ai.settings.escalations.rules.description": "Keywords / Phrase",
  "ai.settings.escalations.rules.details":
    "Type a word or phrase guests might use",
  "ai.settings.escalations.rules.build": "Built-in rules",
  "ai.settings.escalations.rules.custom": "Custom rules",
  "ai.settings.escalations.rules.delete.title":
    "Are you sure you want to delete this rule?",
  "ai.settings.escalations.rules.delete.desc":
    "Deleting this rule will prevent this type of escalation from being triggered again",
  "ai.settings.workingHours": "Working hours",
  "ai.settings.workingHours.desc":
    "When an escalation occurs outside these hours, the AI agent will let the guest know we're offline before alerting staff",
  "ai.settings.workingHours.enable": "Working hours enabled",
  "ai.settings.workingHours.disabled": "Working hours disabled",

  "ai.settings.followUps": "Follow-ups",
  "ai.settings.followUps.desc":
    "Sends automatic follow-ups when a user becomes inactive. The AI analyzes the context and only sends them when appropriate.",
  "ai.settings.followUps.enable": "Follow-ups enabled",
  "ai.settings.followUps.enable.desc":
    "When enabled, the AI agent may follow up with users who go inactive, depending on the situation.",
  "ai.settings.followUps.disabled": "Follow-ups disabled",
  "ai.settings.followUps.delay": "Follow-up delay",
  "ai.settings.followUps.delay.desc":
    "Choose how long to wait before evaluating and sending a follow-up.",
  "ai.settings.followUps.delay.option.half": "0.5h",
  "ai.settings.followUps.delay.option.hours": "{hours}h",
  "ai.settings.followUps.likelihood": "Follow-up likelihood",
  "ai.settings.followUps.likelihood.desc":
    "Controls how strict the AI is before sending a follow-up.",
  "ai.settings.followUps.likelihood.high": "High",
  "ai.settings.followUps.likelihood.default": "Default",
  "ai.settings.followUps.likelihood.low": "Low",

  "ai.settings.aiBookings": "AI Bookings",
  "ai.settings.aiBookings.desc":
    "When enabled, the AI agent can manage bookings and payments.",
  "ai.settings.aiBookings.enable": "AI Bookings enabled",
  "ai.settings.aiBookings.enable.desc":
    "When enabled, the AI agent can manage bookings and payments.",
  "ai.settings.aiBookings.disabled": "AI Bookings disabled",
  "ai.settings.aiBookings.connectedAccount": "Stripe connected account",
  "ai.settings.aiBookings.depositPercentage":
    "Deposit required as a percentage of the total booking (%). 100 means full payment upfront.",
  aiSettingsWorking: "We are preparing your business information",
  aiSettingsOptimizing: "We are optimizing your business information",
  aiSettingsOptimizingDesc:
    "We are optimizing the information extracted from your website",
  aiSettingsKnowledge: "AI Learning Hub",
  aiSettingsKnowledgeDesc:
    "Here, you can provide information to train the AI. Test the AI on the right to see what your customers will experience.",
  aiSettingsAlert:
    "Here, you can provide information to train the AI. Test the AI on the right to see what your customers will experience.",
  aiSettingsFreeText: "Free Text",

  aiSettingsReset: "Reset",
  aiSettingsCall: "Call",
  aiSettingsCalling: "Calling",
  aiSettingsCallConnected: "Connected",
  aiSettingsMicPermission: "Allow microphone access to continue",

  aiSettingsHangup: "Hang up",
  aiSettingsAssitant: "Meet Lana! Your virtual assistant",
  aiSettingsAssitantDesc:
    "This is where you can experiment and interact with Lana to understand exactly what your customers will experience from the AI's responses.",
  aiSettingsSaving: "Saving changes...",
  aiExceededLength: "You exceeded the content length",
  aiCompanyTitle: "{company}",
  aiPoweredBy: "Powered by",
  aiCompanyWelcomeTitle: "Welcome to {company} virtual assistant",
  aiCompanyFormDesc: "Enter your name",
  aiCompanyExplore: "Continue",
  aiShare: "Share your virtual assitant",
  aiCrawl: "Let's fetch your website and teach your AI Agent!",
  aiCrawling: "Your AI is crawling the website",
  aiCrawlingWebsiteSucc: "Website analysis completed",
  aiCrawlingSuccess: "Success! Your website was crawled",
  aiCrawlingSuccessDesc:
    "Your information has been fetched and ready for your review",
  aiCrawlingFailed:
    "There was a problem analyzing your website, please try again later",
  aiCrawlingSkip: "Do you want to continue without analyzing your website?",
  aiCrawlingSkipDesc:
    "Analyzing your website will help your AI assistant deliver better results.",
  aiReview: "Let's review",
  aiAgent: "AI Agent",
  aiAgentCreated: "Your AI agent is created",
  aiUpdateCta: "Edit",
  aiUpdateSucces: "Your AI agent has been updated",
  aiGeneralContext: "General Information",
  aiProviderContext: "Provider Information",

  "account.successAdded":
    "The invitation has been accepted, and you now have access to the account.",
  "account.acceptInvitation.title": "Accept Invitations",
  "account.acceptInvitation.pageDescription":
    "Please accept your pending invitations.",
  "account.acceptInvitation.account": "Account name",
  "account.acceptInvitation.noPending":
    "You don't have any pending invitations...",

  "account.createAccount.title": "Create a new account",
  "account.createAccount.pageDescription": "Enter the new account company name",

  "channels.title": "Channels",
  "channels.account": "Account",
  "channels.autoReplies": "AI auto replies",
  "channels.waTitle": "Connect your business WhatsApp numbers",
  "channels.waDescription":
    " Automate whatsapp convesations or manually respond in live Chat",
  "channels.igTitle": "Connect your instagram account",
  "channels.igDescription":
    "Automate inbox messages or manually respond in live chat.",
  "channels.fmTitle": " Connect facebook messenger",
  "channels.fmDescription":
    "Automate messenger chats or manually respond using messenger app.",
  "chats.aiAuto":
    "AI auto-reply. If disabled, the AI will not automatically respond to incoming messages.",
  "chats.markAsOpen": "Mark as review",
  "chats.markAsClose": "Mark as resolved",
  "chats.archive": "Archive chat",
  "chats.unArchive": "Unarchive chat",
  "chats.archived": "Archived",
  "chats.accounts": "Accounts",
  "chats.all": "All",
  "chats.filters": "Filters",
  "chats.isGuest": "Guest",
  "chats.isBook": "Booking Offered",
  "chats.book": "Booking Offered",
  "chats.isManual": "Manual Conversation",
  "chats.fileCaptionPlaceholder": "Add a caption...",
  "chats.ai.isManual": "Manual Conversation",

  "chats.escalated.explanation":
    "Chats that have been escalated by the AI and require review",

  "chats.isManual.explanation":
    "Chats that include at least one manual response",

  "chats.enabled.explanation": "Chats where AI responses are disabled",

  "chats.assignation": "Assignment",

  "chats.isConversion": "Conversion",
  "chats.outbound_conversion": "Outbound Conversion",
  "chats.payment_received": "AI Booking",
  "chats.unblockContact": "Unblock Contact",
  "chats.blockContact": "Block Contact",
  "chats.help": "Requested help",
  "chats.contactOptedOut": "El contacto se ha dado de baja",
  "chats.enabled": "Manual",
  "chats.followUp": "Smart follow-up",
  "chats.blocked": "Blocked",
  "chats.reply": "Reply",
  "chats.clone": "Clone to playground",
  "chats.flag": "Report",
  "chats.filter": "Filter",

  "chats.userMessage": "User message",
  "chats.assistantResponse": "AI response",
  "chats.expectedResponse": "Expected response",
  "chats.updateAnswer": "Report wrong answer",
  "chats.expectedResponsePlaceholder": "Write the ideal response here...",
  "chats.ad": "Advertisement",
  "chats.escalated": "Review",
  "chats.isPayment": "Payment link issued",
  "chats.isBooked": "Has booked",
  "contactDetail.header": "Information",
  "contactDetail.title": "Contact Profile",
  "contactDetail.leadInfo": "Lead Information",
  "contactDetail.actions": "Chat Activity",
  "contactDetail.bookings": "Bookings",
  "contactDetail.followers": "followers",
  "contactDetail.toolCalls": "Activity",
  "contactDetail.loadingChat": "Loading messages...",
  "contactDetail.assignation": "Chat assignment",
  "contactDetail.assignUser": "Assign a user to this chat",
  "contactDetail.unassignUser": "Unassigned",
  "toolCalls.help": "Asked for help",
  "toolCalls.manual": "Manual review",
  "toolCalls.book": "Asked availability",
  "toolCalls.availability": "Asked availability",
  "toolCalls.pricing": "Asked for price",
  "toolCalls.payment_received": "Payment done",
  "toolCalls.follow_up_after_inactivity": "Smart follow-up",
  "chats.newMessageInput": "Enter Message...",
  "chats.bucket.all": "All",
  "chats.bucket.mine": "Mine",
  "chats.bucket.mine.explanation":
    "Chats you have answered or that are assigned to you.",
  "chats.bucket.pending": "Needs review",
  "chats.bucket.pending.explanation":
    "Chats escalated by the AI that need review",
  "chats.searchContact": "Search Contact...",
  "chats.emptyStateTitle": "No conversations yet",
  "chats.emptyStateSubtitle": "Your chat list awaits your first message",
  "chats.emptyStateEscTitle": "No conversations found",
  "chats.emptyStateEscSubtitle": "Remove the filters or search for a contact",
  "chats.emptyStatePendingTitle": "No conversations need your action",
  "chats.emptyStatePendingSubtitle":
    "Great job! There are no conversations that need your action at this time.",
  "chats.emptyWelcomeTitle": "No conversation selected",
  "chats.emptyWelcomeSubtitle":
    " Choose a conversation from the left to view its messages.",
  "chats.searchNoResults": "No results found",
  "chats.searchStart": "Start typing to search",
  "interactive.call.summary": "Call summary",
  "interactive.call.active": "Call active",
  "integrations.title": "Integrations",

  "integrations.waSettings": "WhatsApp Settings",
  "integrations.waPaymentMethod": "Set Up Payment",

  "integrations.deleteTitle":
    "Are you sure you want to delete this integration?",
  "integrations.deleteDesc":
    "This action is irreversible. The integration will stop working immediately, and you’ll need to reconnect it if you want to use it again.",
  "integrations.alert.title": "Not available in your plan",
  "integrations.alert.description":
    "Your current plan doesn't include access to this channel or integration. To enable it, please upgrade your plan.",
  "integrations.alert.billing": "Upgrade plan",
  "integrations.alert.dismiss": "Got it",

  "integrations.alert.wa.title": "Connecting WhatsApp can be tricky",
  "integrations.alert.wa.description":
    "Meta enforces strict rules when connecting a WhatsApp number. Common issues include number rejections, the need to delete it from the app, and unexpected blocks. We strongly recommend reading our step-by-step guide or booking a quick call with our team. You can also continue on your own if you prefer.",
  "integrations.alert.wa.guide": "Read our guide",
  "integrations.alert.wa.button": "Book onboarding call",
  "integrations.alert.wa.continue": "Continue anyway",

  "integrations.wordpress": "WordPress Plugin",
  "integrations.degradedStatus": "Error detected",
  "integrations.wordpressInstructions":
    "To use Visito AI on WordPress, follow these steps:",
  "integrations.wordpressStep1": "Install the Visito plugin:",
  "integrations.wordpressStep2":
    "Activate the plugin and paste your API key in your WordPress dashboard under Settings > Visito AI.",

  "integrations.webChat": "Share your AI agent",
  "integrations.webName": "Web Chat",
  "integrations.playName": "Playground Chat",
  "integrations.webChatDescription":
    "Copy the link below to share your AI agent",
  "integrations.embedChat": "Embed a chat bubble in your website",
  "integrations.embedChatDescription":
    "Copy the code below to embed your AI agent in your source code",
  "integrations.webChatLaunchTarget": "Bubble action",
  "integrations.webChatLaunchTargetDescription":
    "Choose whether the bubble opens your web chat or redirects to WhatsApp.",
  "integrations.webChatLaunchWebchat": "Website chat",
  "integrations.webChatLaunchWhatsappPrefix": "WhatsApp",
  "integrations.webChatBubbleColor": "Bubble color",
  "integrations.webChatBubbleColorDescription":
    "This color applies to the embedded chat bubble on all websites using this API key.",
  "integrations.webChatWidgetDesktopSize": "Widget size (desktop)",
  "integrations.webChatWidgetMobileSize": "Widget size (mobile)",
  "integrations.webChatWidgetWidthPx": "Width (px)",
  "integrations.webChatWidgetHeightPx": "Height (px)",
  "integrations.webChatWidgetWidthVw": "Width (vw)",
  "integrations.webChatWidgetHeightVh": "Height (vh)",
  "integrations.webChatWidgetSizeDescription":
    "Desktop accepts 280-1000px width and 400-1400px height. Mobile accepts 50-100vw width and 50-100vh height.",
  "integrations.copyLink": "Copy",
  "integrations.visitLink": "Open",
  "integrations.propertiesListTitle": "Properties",
  "integrations.noProperties": "No Properties Found",

  "integrations.acceptNewIntegration":
    "Please accept new incoming integration from {provider}",
  "integrations.completedNewIntegration":
    "You have succesfully accepted the integration with {provider}",
  "integrations.completedDbIntegration": "Integration added successfully",

  "integrations.webChatName": "Web Chat",
  "integrations.fmName": "Messenger",
  "integrations.waName": "WhatsApp",
  "integrations.cbName": "Cloudbeds",
  "integrations.haName": "Hostaway",
  "integrations.igName": "Instagram",
  "integrations.smName": "SiteMinder",
  "integrations.shopName": "Shopify",
  "integrations.wpName": "WooCommerce",
  "integrations.gsName": "Guesty",
  "integrations.miraiName": "Mirai",
  "integrations.mwName": "Mews",
  "integrations.voiceName": "Voice",
  "integrations.wxName": "Wix Hotels",
  "integrations.hrName": "HotelRunner",

  "integrations.manualReplies": "AI automation is paused.",
  "integrations.autoReplies": "AI automation is active. ",

  "integrations.pmsActive": "Access is active.",
  "integrations.pmsPaused": "Access is paused.",

  "integrations.igReconnect": "Add or remove accounts",
  "integrations.waReconnect": "Add or remove numbers",
  "integrations.fmReconnect": "Add or remove pages",
  "integrations.voiceReconnect": "Add or remove phones",
  "integrations.wpReconnect": "Add or remove stores",
  "integrations.shopReconnect": "Add or remove stores",

  "integrations.smReconnect": "Add new properties",
  "integrations.cbReconnect": "Add new properties",
  "integrations.gsReconnect": "Add new properties",
  "integrations.haReconnect": "Add new properties",
  "integrations.mwReconnect": "Add new properties",
  "integrations.wxReconnect": "Add new properties",
  "integrations.hrReconnect": "Add new properties",

  "integrations.smAdd": "Add a new SiteMinder property",
  "integrations.gsAdd": "Add a new Guesty property",
  "integrations.mwAdd": "Add a new Mews property",
  "integrations.wpAdd": "Add a new WooCommerce store",
  "integrations.shopAdd": "Add a new Shopify store",
  "integrations.wxAdd": "Add a new Wix Hotels property",
  "integrations.hrAdd": "Add a new HotelRunner property",

  "integrations.guide": "Integration guide",
  "integrations.missingInformation":
    "Your integration is missing some required information. Please check the integration guide and click ‘Manage’ to complete your account settings.",

  "integrations.nameDb": "Name",
  "integrations.refreshTokenDb": "API Secret",
  "integrations.clientIdDb": "API Client ID",
  "integrations.integrationTokenDb": "Integration Token",
  "integrations.propertyIdDb": "Property ID",
  "integrations.widgetIdDb": "Booking engine widget ID",
  "integrations.publisherDb": "Publisher",
  "integrations.currencyDb": "Currency",
  "integrations.countryCodeDb": "Select country",
  "integrations.phoneNumberDb": "Phone Number",
  "integrations.tokenDb": "API Token",
  "integrations.websiteDb": "Website URL",

  "integrations.timezoneDb": "Timezone",
  "integrations.bookingEngineDb": "Booking Engine",
  "integrations.xXsrfTokenDb": "X-Xsrf-Token",
  "integrations.xWixInstanceDb": "X-Wix-Instance",
  "integrations.wixBookingBaseUrlDb": "Wix booking base URL",
  "integrations.hotelrunnerApiKeyDb": "HotelRunner API key",
  "integrations.hotelrunnerOTokenDb": "HotelRunner o_token",
  "integrations.hotelrunnerONumberDb": "HotelRunner o_number",
  "integrations.hotelrunnerChallengeDb": "X-HR-Challenge",
  "integrations.hotelrunnerBaseUrlDb": "HotelRunner base URL",

  "integrations.nameDbPlaceholder": "Hotel Santa Fe",
  "integrations.integrationTokenDbPlaceholder":
    "Paste your Guesty integration token (one-time use, expires in 4 hours)",
  "integrations.refreshTokenDbPlaceholder":
    "Your API secret from guesty API dashboard",
  "integrations.clientIdDbPlaceholder":
    "Your Client ID from guesty API dashboard",
  "integrations.propertyIdDbPlaceholder": "28093",
  "integrations.widgetIdDbPlaceholder": "santafedirect",
  "integrations.publisherDbPlaceholder": "littlehotelier",
  "integrations.currencyDbPlaceholder": "MXN",
  "integrations.countryCodeDbPlaceholder": "CO",
  "integrations.phoneNumberDbPlaceholder": "5585655477",
  "integrations.tokenDbPlaceholder": "shpat_*****************************",
  "integrations.websiteDbPlaceholder": "https://mystore.com",
  "integrations.xXsrfTokenDbPlaceholder": "1775664531|KKHB0gLdhXRI",
  "integrations.xWixInstanceDbPlaceholder": "eyJpbnN0YW5jZUlkIjoi...",
  "integrations.wixBookingBaseUrlDbPlaceholder": "https://www.myhotel.com/rooms",
  "integrations.hotelrunnerApiKeyDbPlaceholder":
    "7518391247a27ce412d421ffe241c6ffd3f52e7c4b26e993",
  "integrations.hotelrunnerOTokenDbPlaceholder":
    "a8c4516976fe2feffcbe173925822c7c",
  "integrations.hotelrunnerONumberDbPlaceholder": "R076950164",
  "integrations.hotelrunnerChallengeDbPlaceholder": "609402",
  "integrations.hotelrunnerBaseUrlDbPlaceholder":
    "https://your-property.hotelrunner.com",

  "integrations.pageTitle": "Integrations",
  "integrations.pageConnectTitle": "Channels",

  "integrations.pageDescription":
    "Connect your assistant to key communication channels and data sources",

  "integrations.fmDescription": "Connect your Facebook pages",
  "integrations.waDescription": "Connect your Whatsapp number",
  "integrations.cbDescription": "Connect your Cloudbeds properties",
  "integrations.haDescription": "Connect your Hostaway properties",
  "integrations.igDescription": "Connect your Instagram accounts",
  "integrations.smDescription": "Connect your SiteMinder properties",
  "integrations.gsDescription": "Connect your Guesty properties",
  "integrations.miraiDescription": "Connect your Mirai Booking Engine",
  "integrations.mwDescription": "Connect your Mews properties",
  "integrations.wpDescription": "Connect your WooCommerce store",
  "integrations.shopDescription": "Connect your Shopify store",
  "integrations.voiceDescription": "Connect your Phone Number",
  "integrations.wxDescription": "Connect your Wix Hotels properties",
  "integrations.hrDescription": "Connect your HotelRunner properties",

  "teams.title": "Team Management",
  "teams.subTitle": "Manage access for team members",
  "teams.selectorLabel": "Role",
  "teams.rol.admin": "Admin",
  "teams.rol.user": "User",
  "teams.emailLabel": "Email",
  "teams.button": "Invite",
  "teams.message.success": "An invitation link has been sent to your email.",
  "teams.inviteMember": "Invite member",
  "teams.passwordLabel": "Password",
  "teams.buttonAccept": "Accept",
  "teams.inviteInfo": "Accept invitation to Teams",
  "teams.modalMessageTitle.success": "Successful invitation",
  "teams.modalMessageTitle.error": "Error sending invitation",
  "teams.modal.button": "Close",
  "invitedList.Members": "Members",
  "invitedList.Invites":
    "{count, plural, one {# invitation remanining} other {# invitations remanining}}",
  "invitedList.emailLabel": "Email",
  "invitedList.roleLabel": "Role",
  "invitedList.dateLabel": "Joined",
  "invitedList.title.deleteSuccess": "Delete user",
  "invitedList.message.deleteSuccess": "User deleted successfully",
  "invitedList.message.deleteError": "Error deleting user",
  "payment.title": "Billing",
  "payment.subTitle":
    "Manage your payment methods, subscriptions and billing details",
  "payment.changePlan": "Change to this plan",
  "payment.changePlanPayNow": "Change to this plan and pay now",
  "payment.planTier":
    "{credits, number} message credits - {price, number, ::currency/USD}/mo",
  "payment.planTierMonthly":
    "{credits, number} message credits - {price, number, ::currency/USD}/mo",
  "payment.planTierAnnual":
    "{credits, number} message credits - {price, number, ::currency/USD}/yr",
  "payment.monthly": "Monthly",
  "payment.annual": "Annual",
  "payment.billingCycle": "Billing cycle",
  "payment.currentPlan": "Current plan",
  "payment.managePlan": "Manage payment",
  "payment.manageCurrentPlan":
    "Manage your plan - upgrade anytime to increase your message credits limit",
  "payment.billingEmail": "Billing Email",
  "payment.noPlanAlert":
    "You are not subscribed to any plan. Subscribe to a plan to increase your message credits limit.",
  "payment.selectAPlan": "Select a Plan",
  "payment.subscribe": "Subscribe to this plan",
  "payment.downgradeScheduled": "Downgrade scheduled for {date}",
  "payment.pendingDowngrade": "Pending downgrade on {date}",
  "payment.currentPlanUntil": "Current plan: {plan} until {date}",
  "payment.scheduledPlanFrom": "Scheduled plan: {plan} from {date}",
  "payment.scheduledPlan": "Scheduled plan (starts {date})",
  "payment.planNoop": "You are already on this plan",
  "payment.planNoopCurrent": "You are already on this current plan",
  "payment.planNoopScheduled": "This downgrade is already scheduled for {date}",
  "payment.portalError": "Unable to open billing portal, please try again later",
  "usage.title": "Usage",
  "usage.customRangeTitle": "Custom date range",
  "usage.subTitle": "Track daily billable credit usage for your current cycle",
  "usage.filterBillingCycle": "Current billing cycle",
  "usage.kpiTotal": "Total billable credits",
  "usage.kpiAverage": "Average per day",
  "usage.kpiPeak": "Peak day",
  "usage.empty":
    "No billable credit activity yet for this period. Check back after more conversations.",
  "usage.error": "Could not load usage data right now. Please try again in a moment.",
  "usage.axisCredits": "Credits",
  "usage.creditsUsed": "credits used",
  "usage.seriesBillable": "Billable credits",
  "language.title": "Language",
  "language.subTitle":
    "Select the language you will like to change the platform to",
  "language.selectorLabel": "Select Language",
  "language.english": "English",
  "language.spanish": "Español",
  "language.portuguese": "Português",
  "language.languages": "Languages",
  "language.en_US": "English",
  "language.es_MX": "Spanish",
  "language.pt_BR": "Portugues",

  "home.statsTitle": "Last 30 days stats",
  "home.planTitle": "Current plan stats",
  "home.pageTitle": "Hi",
  "home.pageDescription": "Welcome to your Visito dashboard",
  "home.skip": "Skip onboarding",

  "home.onboardingTitle": "Get Started",
  "home.onboardingDescription":
    "Complete the steps below to fully setup your account",

  "home.title_account": "Create your account",
  "home.description_account":
    "Manage all communications in a single Visito inbox",

  "home.title_location": "Connect a property",
  "home.description_location": "Integrate your property with Visito",

  "home.title_channel": "Connect a channel",
  "home.description_channel": "Connect a channel to start receiving messages",

  "home.title_wa": "Connect WhatsApp",
  "home.description_wa": "Reach over 2 billions customers globally",

  "home.title_fm": "Connect Facebook Messenger",
  "home.description_fm": "Boost support and bookings with Facebook Messenger",

  "home.title_ig": "Connect Instagram",
  "home.description_ig":
    "Connect your Instagram account inbox to start receiving messages",

  "home.messageLimit": "Remaining message credits",
  "home.messageResetDate": "Restart date",
  "home.remainingQuotaOutOf": "{remaining} remaining out of {limit}",
  "home.quotaLeft": "Credits: {remaining} / {total} ({pct}%)",
  "home.trialBadge": "Trial · {days}d left",
  "home.trialEndsOn": "Trial ends on {date}",
  "home.trialNoticeTitle": "Free trial active",
  "home.trialNoticeBody":
    "Your card will be charged on {date} unless you cancel before then.",
  "home.trialNoticeCta": "Manage billing",
  "home.descriptionLimit":
    "{count, plural, one {# message} other {# messages}} available of {messageLimit, number}",
  "home.dateLimit": "Resets on {date}",
  "home.increaseLimit": "Upgrade plan",
  "home.limitReached": "Limit reached",
  "home.nearLimit": "Near limit",
  "home.plentyLeft": "Plenty left to use",
  "home.messagesUnderReview": "Messages under review",
  "home.unreadManualMessages": "Unread manual messages",
  "home.links": "Quick links",
  "home.planUsageHelper": "Remaining",
  "home.requiresAction": "Messages that require your action",

  "home.title_ai": "Configure your AI training sources",
  "home.description_ai": "Program your AI agent with the right information",
  "home.pendingItems": "pending items",
  "home.uniqueContacts": "Unique Contacts",
  "home.totalMessages": "Total Messages",
  "home.percentageAuto": "AI Resolutions (%)",
  "home.noStats":
    "It looks like there's no data yet. Please check back later or adjust your filters.",
  "home.maintenance": "We'll be right back 🛠️",
  "home.maintenance.desc":
    "We're making some improvements to offer you a better experience. Your information is safe, and we'll be back shortly",
  "home.updateApp": "Update required",
  "home.updateApp.desc":
    "A new version ({remoteVersion}) is available. Please update the app to continue.",
  "home.updateApp.btn": "Update now",

  "leads.intent": "Summary",
  "leads.score": "Quality",
  "leads.high": "High",
  "leads.medium": "Medium",
  "leads.low": "Low",
  "leads.no_score": "no score",
  "leads.filter.actions": "Chat Activity",
  "leads.filter.company": "Filter by account",
  "leads.stats.book": "Availability",
  "leads.stats.pricing": "Issued payment link",
  "leads.stats.payment_received": "Has booked",
  "leads.stats.payment_receivedExplanation":
    "Booking completed successfully in the chat",
  "leads.stats.availability": "Availability",
  "leads.stats.availabilityExplanation":
    "Asked about availability in the chat.",
  "leads.stats.opt_in": "Opted in",
  "leads.stats.total": "All",
  "leads.stats.help": "Requested Help",
  "leads.stats.paid": "Paid",
  "leads.stats.arrival_time": "Arrival time",
  "leads.stats.confirm": "Confirmed",
  "leads.stats.postConfirm": "Confirmed",
  "leads.stats.reservation_details": "Asked details",
  "leads.stats.rating": "Has rated",
  "leads.stats.generate_payment_link": "Issued payment link",
  "leads.stats.postConfirmError": "Something went wrong",
  "leads.datePlaceholder": "Date",
  "leads.pageTitle": "Leads",
  "leads.followUp": "Follow Ups",
  "leads.pageDescription":
    "Potential customers that have started a conversation",
  "leads.noScoreExplanation": "No score available yet",
  "leads.noIntent": "-",
  "leads.noIntentExplanation":
    "The AI hasn’t identified the user’s intent in this conversation yet. It will be updated once the conversation is analyzed.",
  "leads.noLeads": "No leads found",
  "leads.followUpStatus.no_follow_up": "-",
  "leads.followUpStatus.pending": "Being evaluated",
  "leads.followUpStatus.followed_up": "Sent",
  "leads.followUpStatus.rejected": "Not recommended",
  "leads.followUpStatus.howManySent": "{count} sent",

  "leads.followUpStatus.no_follow_upExplanation": "No follow-ups.",
  "leads.followUpStatus.pendingExplanation":
    "The AI is currently evaluating whether a follow-up is needed based on the user's last interaction. {count, plural, =0 {} other {Previously, {count} follow-up(s) were sent.}}",
  "leads.followUpStatus.followed_upExplanation":
    "The AI has sent a follow-up message to re-engage the user. {count, plural, one {One follow-up has been sent.} other {{count} follow-ups have been sent.}}",
  "leads.followUpStatus.rejectedExplanation":
    "The AI determined that no follow-up was needed. {count, plural, =0 {} one {One follow-up was sent before.} other {{count} follow-ups were sent before.}}",

  "leads.isBook": "Asked availability",
  "leads.isPayment": "Issued payment link",
  "leads.isBooked": "Has booked",
  "leads.escalated": "Marked for review",
  "leads.isManual": "Answered manually",
  "leads.help": "Requested help",
  "leads.export": "Export",
  "leads.date": "Last Message",
  "leads.payments.pageTitle": "Payments",
  "leads.payments.date": "Date",
  "leads.payments.bookings": "Bookings",
  "leads.payments.reference": "Reference",
  "leads.payments.status": "Status",
  "leads.payments.makeArefund": "Refund",
  "leads.payments.paymentRequested": "Payment Requested",
  "leads.payments.fees": "Stripe Fees",
  "leads.payments.commission": "Visito Commission",
  "leads.payments.refunded": "Refunded",
  "leads.payments.paymentBreakDown": "Payment Breakdown",
  "leads.payments.netAmount": "Subtotal",
  "leads.payments.providerNetAmount": "Total",
  "leads.payments.transferStatus": "Transfer Status",
  "leads.payments.amount": "Amount",
  "leads.payments.transfered": "Transferred",
  "leads.payments.pendingTransfer": "Pending transfer",
  "leads.payments.expired": "Expired",
  "leads.payments.active": "Not Paid",
  "leads.payments.pending": "Pending",
  "leads.payments.paid": "Paid",
  "leads.payments.refunds": "Refunds",
  "leads.payments.reconciled": "Reconciled",
  "leads.payments.transferFunds": "Run transfer job",
  "leads.payments.hydrateBalance": "Run balance hydration",
  "leads.payments.viewConversation": "View Conversation",
  "leads.payments.refundPayment": "Refund payment",
  "leads.payments.refundAmount": "Refund amount",
  "payments.stripe.title": "Stripe Express payouts",
  "payments.stripe.connectMessage":
    "Connect your bank account to start receiving in-chat payments from your guests.",
  "payments.stripe.landingHeadline":
    "Start receiving in-chat payments for your business",
  "payments.stripe.landingSubheadline":
    "Connect your bank account to charge products, services, or bookings directly in chat.",
  "payments.stripe.docsInChatPayments": "In-chat payments docs",
  "payments.stripe.docsItemsCatalog": "Items catalog docs",
  "payments.stripe.connect": "Connect your bank account",
  "payments.stripe.connectedAccount": "Connected account: {account}",
  "payments.stripe.itemsToggleLabel": "Enable item payments in chat",
  "payments.stripe.itemsToggleHelp":
    "Allow the AI to generate payment links for items in your catalog.",
  "payments.stripe.payoutsToggle":
    "Enable in-chat payment capture (instead of redirecting to booking engine)",
  "payments.stripe.depositPercentageLabel": "Deposit to charge in chat",
  "payments.stripe.depositPercentageHelp":
    "Choose from 1% to 100% of the booking total.",
  "payments.stripe.openExpress": "Open Stripe Express",
  "payments.stripe.disconnect": "Disconnect",
  "payments.stripe.disconnectSuccess": "Stripe account disconnected",
  "payments.items.title": "Items Catalog",
  "payments.items.subtitle":
    "Create products or services the AI can charge directly in chat.",
  "payments.items.name": "Name",
  "payments.items.namePlaceholder": "e.g. Day pass",
  "payments.items.description": "Description",
  "payments.items.descriptionPlaceholder": "e.g. Full-day access to pool and facilities",
  "payments.items.price": "Price",
  "payments.items.pricePlaceholder": "e.g. 20.00",
  "payments.items.currency": "Currency",
  "payments.items.active": "Active item",
  "payments.items.propertiesTitle": "Item details",
  "payments.items.propertiesSubtitle":
    "Capture context for each sale (date, option, notes, etc.).",
  "payments.items.addProperty": "Add detail",
  "payments.items.propertiesEmpty": "No details configured.",
  "payments.items.propertyLabel": "Detail label",
  "payments.items.propertyLabelPlaceholder": "e.g. Day",
  "payments.items.propertyType": "Detail type",
  "payments.items.propertyRequired": "Required detail",
  "payments.items.propertyType.date": "Date",
  "payments.items.propertyType.enum": "Enum",
  "payments.items.propertyType.text": "Text",
  "payments.items.propertyType.number": "Number",
  "payments.items.propertyEnumOptions": "List options",
  "payments.items.propertyEnumOptionPlaceholder": "e.g. Deep tissue",
  "payments.items.propertyAddOption": "Add option",
  "payments.items.propertiesCount":
    "{count, plural, one {# detail} other {# details}}",
  "payments.items.docs": "Docs",
  "payments.items.create": "Create item",
  "payments.items.update": "Update item",
  "payments.items.cancelEdit": "Cancel edit",
  "payments.items.empty": "No items created yet.",
  "payments.items.statusActive": "Active",
  "payments.items.statusInactive": "Inactive",
  "payments.items.edit": "Edit",
  "payments.items.deactivate": "Deactivate",
  "payments.items.delete": "Delete",
  "payments.items.deleteConfirm": "Delete this item?",
  "payments.items.validationError":
    "Please complete item name, price, currency, and valid details before saving.",
  "payments.tabs.stripeAccount": "Stripe account",
  "payments.tabs.bookingSettings": "Booking settings",
  "payments.tabs.itemSettings": "Item settings",
  "payments.booking.connectStripeFirst":
    "Connect your Stripe account first to configure booking settings.",
  "leads.payments.itemProperties": "Item details",

  "outbound.event": "Event",
  "outbound.pageTitle": "Events",
  "outbound.pageDescription":
    "Enhance guest engagement with automated communication triggers throughout the reservation journey",
  "outbound.viewEvent": "View event",
  "outboud.messagesSent": "Messages sent in the last 30 days",
  "outbound.reservation":
    "After a guest completes their reservation, the guest receives a confirmation message with booking details.",
  "outbound.time_reservation": "Sent inmidiately",
  "outbound.arrival":
    "Before arrival, the guest receives a message with helpful information about their stay.",
  "outbound.time_arrival": "2 days before arrival",
  "outbound.stay":
    "After the guest checks in, the guest receives a message with special instructions and useful information",
  "outbound.time_stay": "Sent inmidiately after arrival",
  "outbound.after_departure":
    "After the guest checks out, the guest receives a thank-you message along with a feedback request.",
  "outbound.time_after_departure": "Sent immediately after guest checks out",
  "outbound.inactiveTitle": "Are you sure you want to inactive this event?",
  "outbound.inactiveDesc":
    "Turning this event off will not trigger the responses to go out",
  "outbound.disabling": "Disabling event...",
  "outbound.cardTitle": "Outbound events",
  "outbound.recentActivity": "Recent Activity",
  "outbound.noActivity": "No activity",
  "outbound.missingChannel":
    "Oops! You haven't connected a WhatsApp number to your account yet.",
  "outbound.missingChannelDesc":
    "Connect your WhatsApp number to engage with your guests during reservations, arrivals, and after their departure.",
  "outbound.missingChannelCTA": "Click here to connect",
  "outbound.modifyTemplate": "Modify template",
  "outbound.templateTitle": "Edit {template} ",
  "outbound.templateLastUpdate":
    "Last modified: {date} (Modified {count, plural, one {# time} other {# times}} within 30 days )",
  "outbound.templateLangDesc":
    "Modify the message you want to send to guests in {lang}",
  "outbound.templatePreview": "Preview message",
  "outbound.templatePreviewDesc": "Below is what your message will look like",
  "outbound.templateVarsInfo":
    "You can need to make sure the tags are entered properly. Reference below for what tags you can use",
  "outbound.templateVardDesc": "Use these tags in the message body",
  "outbound.templateTag": "Tag",
  "outbound.templateFunction": "Function",
  "outbound.template_confirmationId": "Confirmation number",
  "outbound.template_username": "The full name of the contact",
  "outbound.template_checkin": "Guest check in date",
  "outbound.template_checkout": "Guest check out date",
  "outbound.template_status_PENDING":
    "New template changes are under review This may take up to 24 hours until the new changes are approved.You can't modify the submitted template until review is completed.",
  "outbound.template_status_REJECTED":
    "Your changes has been rejected because of the following reason: {reason}",
  "outbound.template_status_LESS_THAN_ONE_DAY":
    "Wait 24 hours from the last update to edit the template again",
  "outbound.templateReviewTitle":
    "Are you sure you want to submit these new changes for review?",
  "outbound.templateReviewDesc":
    "Submitting for review will take up to 24 hours to get approved. You will be locked out of making further changes.",
  "outbound.templateSend": "Yes, send for review",
  "outbound.templateSendForReview":
    "The template has been sent for review, the approval process may take up to 24 hours",
  "outbound.template_review_url": "Link for positive reviews", // Liga para reseñas positivas
  "outbound.template_review_url_Desc":
    "This link will be included if the review is positive",
  "outbound.template_review_url_Placeholder":
    "https://tripadvisor.com/review/example",
  "outbound.isLanguageActive": "Is Language Active?",

  "outbound.templateNoLang": "Language unavailable",
  "outbound.templateNoLangDescription": "Add this language to get started",
  "onboarding.getStarted": "Get Started",
  "onboarding.pageTite": "Onboarding",
  "onboarding.stepsTitle": "Pick a time to finish your Visito onboarding",
  "onboarding.step1": "Reviewing your property information and chat settings",
  "onboarding.step2":
    "Setting up your communication channels, including WhatsApp and Instagram",
  "onboarding.step3": "Overview of the account features and capabilities",
  "onboarding.step4":
    "Sending test messages and enabling Visito on your digital properties",
  "onboarding.step5": "Answer any other questions you may have!",

  "onboarding.businessInfo": "Your business details",
  "onboarding.businessInfoWorking":
    "Almost there! This should take less than one minute...",
  "onboarding.businessInfoDone": "You’re all set.",
  "onboarding.businessInfoContinue":
    "Review info and continue. You can always edit this later.",
  "onboarding.channelsDone": "You’re all set!",
  "onboarding.continueToDashboard": "Continue to dashboard",
  "onboarding.igConnect": "Automatically connect your account.",
  "onboarding.igConnected": "Your Instagram account has been connected.",

  "onboarding.waConnect": "Get started in minutes.",
  "onboarding.waConnected": "Your WhatsApp phone number has been connected.",
  "onboarding.channelsTitle": "Connect Instagram or WhatsApp to get started:",

  "newConv.Title": "Create a new conversation",
  "newConv.Desc":
    "Enter the Whatsapp number and message below to create a new conversation",
  "newConv.invalidPhone": "Looks like you have entered an incorrect number.",
  "newConv.success": "Message sent successfully",
  "newConv.invalidFile": "The file is invalid",

  "webchat.welcome": "Hi there! 👋 {linebreak}How can we help you today?",
  "webchat.callPrompt": "Talk to {company}",
};

export default lang;
